import { customPalette } from "../../../../theme/theme";

import type { JSX } from "react";

import Typography from "@mui/material/Typography";
import { AttributeGroupProps } from "@plansoft-configuration-renderer/components";
import { useConfigurationAttributeGroupTranslators } from "@plansoft-configuration-renderer/localization";

export type CustomAttributeGroupTitle = Pick<
  AttributeGroupProps,
  "title" | "titleVariant" | "custom"
>;

export function CustomAttributeGroupTitle(
  props: CustomAttributeGroupTitle,
): JSX.Element {
  const { title, titleVariant, custom } = props;
  const translateGroup = useConfigurationAttributeGroupTranslators();
  const groupName = translateGroup.name(title);
  const renderAsCustomPageHeading = custom?.renderAsCustomPageHeading ?? false;

  if (renderAsCustomPageHeading) {
    return (
      <Typography
        variant="h3"
        sx={{
          color: customPalette.primary.main,
          paddingBottom: "8px",
        }}
      >
        {groupName}
      </Typography>
    );
  }

  return <Typography variant={titleVariant}>{groupName}</Typography>;
}
